import { Injectable } from '@angular/core';
import type { ErrorReportContext } from '@core/models/error-report.model';

/**
 * Where production errors go. This default sends them nowhere (the console already shows them); a
 * monitoring vendor plugs in as one provider: `{ provide: ErrorReporter, useClass: VendorReporter }`.
 */
@Injectable({ providedIn: 'root' })
export class ErrorReporter {
  report(_error: unknown, _context: ErrorReportContext): void {
    // No monitoring vendor yet.
  }
}
